import { environ, isNode } from "@ihr-radioedit/sdk-utils";
import { AuthClient } from "./client";
const ENV_ACCESS_TOKEN = "ACCESS_TOKEN";
const ENV_APP_TOKEN = "APP_TOKEN";
const COOKIE_NAME = "access_token";
/**
 * Retrieve the application token within a NODE environment. This reads the
 * local environment variables and will return a located token. Usually in the
 * `APP_TOKEN` key.
 */
export async function requireAppToken() {
    if (isNode) {
        const app_token = environ.get(ENV_APP_TOKEN, "");
        if (app_token) {
            return app_token;
        }
        throw new Error(`NODE SDK usage requires an ${ENV_APP_TOKEN}`);
    }
    throw new Error("getAppToken requires a Node environment");
}
/**
 * Same as requireAppToken but fails with `null` instead of throwing.
 */
export function getAppToken() {
    return requireAppToken().catch(err => Promise.resolve(null));
}
/**
 * Get user token. This function works within a browser environment to find or
 * query the user's token.
 */
export async function requireClientToken() {
    if (!isNode) {
        const access_token = environ.get(ENV_ACCESS_TOKEN, "");
        // NOTE: It's not useful to check cookies here because we cannot verify
        // they'll be good. we're basically just testing if there was a token
        // sent in as an override or fetch one from the auth server.
        if (access_token) {
            console.debug(`${ENV_ACCESS_TOKEN} environment variable provided token`);
            return access_token;
        }
        else {
            try {
                const auth = AuthClient.auto();
                const { _token: token } = await auth.getMyPrincipal();
                console.debug(`${auth.config.baseURL} provided token`);
                return token;
            }
            catch (e) {
                console.error(e);
            }
            throw new Error("Could not acquire a token");
        }
    }
    throw new Error("getClientToken requires a browser environment");
}
/**
 * Same as `requireClientToken` except returns null if it cannot locate a token.
 */
export function getClientToken() {
    return requireClientToken().catch(err => Promise.resolve(null));
}
//# sourceMappingURL=token.js.map